module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("South-west England—spring 1817")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("M")])])])]), _vm._v("aking sure little Susan, who suffered from nightmares, had finally settled into a deep sleep, Joanna Merrill gave the child’s silky hair a gentle pat and slipped from her charge’s side.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Thank’ee, ma’am, and I be sorry to have intruded on your evening,’ the nursemaid Hannah whispered, still rocking Susan’s younger sister in the schoolroom just beyond the little girl’s bed. ‘But I was fair at my wit’s end, what with this one wailing and Miss Susan all afret. Ye’ve got the touch that soothes that little mite. Better get downstairs now, afor you miss your tea.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Having escaped another interminable dinner under the lecherous eye of Lord Masters, her employer’s husband, Joanna had no intention of pouring tea for the family, despite her mistress’s instruction that she return to do so after calming Miss Susan.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, Hannah, I’m feeling weary. I believe I will just return to my room and read.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Very well, miss. Goodnight to you…and be careful.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span', [_vm._v("Joanna had no need of the nursemaid’s cryptic warning. ")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Avoiding Lord Master’s unwanted advances was becoming so great a challenge that, much as she enjoyed the peace of the countryside and her active young charges, Joanna knew she would soon be forced to seek another position, thereby confronting head-on the concern that had prevented her from giving notice within a week of her employers’ arrival in the country—the suspicion that Lord Masters, loath to allow the current object of his wandering eye to escape, would somehow prevent his wife from giving her the necessary references.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("How things had changed in the fortnight since her long-absent employers’ return from London, she thought with a sigh as she tiptoed across the schoolroom. When a friend of her late husband’s family had recommended her for this governess’s position almost a year ago, she’d thought it the answer to her prayers, devastated as she’d been after losing first her babe and then her darling Thomas. Having neither strength nor funds to seek out Papa, still a chaplain with the East India Company, and unwilling to throw herself on her elder brother Greville’s charity, or abase herself by begging assistance from Thomas’s family, who had made clear their disapproval of his marrying the daughter of a untitled country gentleman, she’d been happy to trade the noise and dirt of London for the rural beauty of this remote corner of south-west Hampshire.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Instructing two small girls, at once sweet and demanding, filled her days with an endless activity that left her little time to brood. She’d found a measure of tranquillity that dulled the pain of having to surrender her dreams of building a family and a future with Thomas. A fragile peace that had been shattered within a few days of the arrival of Lady Masters, whom she’d met once the day of her interview, and Lord Masters, whom Joanna had never seen, back at his ancestral estate.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("As she paused on the threshold, peering cautiously into the corridor, she recalled with a bitter smile how charming she’d ")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("thought Lord Masters at their first meeting. Appearing not at all high in the instep, he’d paused to chat with the new employee, enquiring about her family and even claiming friendship with her distant and high-born relation, the Marquess of Englemere, who employed her brother Greville to manage one of his small properties. After she informed Lord Masters how remote was her kinship to this cousin she’d never met and confessed how removed she’d always lived from London society, she expected the Viscount would soon abandon his politeness to a mere governess.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Instead, he’d continued to seek her out, paying her flattering attention as he chatted about literature, art, music and the theatre under the guise of discussing what he considered important for his daughters’ education. Lulled into complacency, she’d noticed nothing untoward until the fourth evening after his arrival…when he’d cornered her alone in the library after dinner.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Still loath to step into the shadowy corridor, she lingered a moment longer, a shudder rippling through her as she recalled that infamous night. Something about his lordship’s gaze, which had seemed to hover with unseemly interest on her bosom, had made her immediately uneasy. The quantity of wine he’d drunk at dinner glazing his eyes, he’d tried to persuade her to remain in the library and talk to him. She’d kept the big desk between them as he entreated her, then walked quickly away, holding the book she’d chosen before her chest like a shield.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Heart thumping like a drum beating the advance, she’d almost managed to escape before, closing the distance between them, he’d reached out and run his fingers over her bottom. The sound of his laughter when she knocked his hand away and scurried out, slamming the door behind her, had chilled her to the core.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Locked inside her room, heart still thrumming in alarm, she’d considered complaining at once to Lady Masters. But what would she do if her employer didn’t believe her?")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lord Masters was a Viscount and her employer’s husband. She was a soldier’s widow, her father an insignificant clergyman currently out of England, the brother she’d not seen in years employed on an estate far away. Who would support her if Lord Masters denied her charges, as he was almost certain to do?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Vowing to remain ever vigilant while she considered the wisest course of action, since that evening she’d kept her chamber door locked and her eyes watchful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she would tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Taking a deep breath, she exited the schoolroom and walked swiftly through dimly lit space towards her room. She’d almost reached that sanctuary when a figure materialised from the shadows further down the hall and strode towards her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Lord Masters,’ she said coolly, despite the dismay that sent her pulse racing. ‘I have the headache a little. Kindly let Lady Masters know I will not take tea this evening.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Ah, then I must eschew tea as well…and tend you. Have you a fever?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She sidestepped his attempt to lay a hand on her forehead. ‘Just a headache, my lord, which solitude and quiet will soon cure. I’m sure your wife, waiting for you below, is most impatient for your return.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘She’s had hers; she can wait,’ he said carelessly, his gaze roving her figure with such blatant relish that she felt besmirched. ‘Whereas you, little fox…It’s been a long time, hasn’t it? Years since that soldier-boy husband of yours sent you back to England? You must be eager…panting for it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he spoke, Joanna had backed away from him towards her chamber until the fingertips she’d extended behind her touched the door latch. Advancing as she retreated, Lord Masters now put both hands on either side of the door frame, corralling her against the door’s solid mahogany panel as he breathed alcoholic fumes into her face.")])])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she darted into her room, could she close the door quickly enough to prevent him from following? Lock it before he could use his greater strength to force it back open?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She might be smaller and weaker, but she’d not give the bastard the satisfaction of knowing how much he frightened her. Summoning her best governess voice, she said repressively, ‘Lord Masters, I find your…attentions most distasteful. Pray recall that you were born a gentleman and abandon them at once.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instead, the Viscount chuckled. ‘What a prim little pet you are! Have I ruffled your sleek russet fur? By heaven, you make me mad to soothe you…to tear off that drab dress and feel the silk of your skin under my fingers.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Alarm extinguishing any further desire to reason with him, Joanna ducked under his outstretched arm and tried to dash away. Laughing in earnest now, he caught her easily, then pinned her against the door and assaulted her with a kiss, his tongue probing her firmly closed lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Furious as well as afraid, despite the limited space between them, Joanna struck at him with as much power as she could muster and bit his tongue.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a yelp of pain, he slammed her into the door, trapping her arms behind her. Covering her mouth with one hand before she could cry out, he wrapped his other arm around her, binding her to him with a punishing grip that left her wriggling to free herself as ineffectually as a worm on a hook.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Like it rough, do you?’ he panted, his beetle-black eyes glistening with excitement. ‘Well, I can accommodate! By God, I’ll have you now, you little vixen.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("Clutching her against him, he kicked open her chamber door. While she continued to struggle, desperately seeking to injure or delay him, he dragged her across the room, threw her backwards on to the bed and climbed atop her, holding ")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("her in place with the bulk of his body. With one hand he started dragging up her skirts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Barely able to breath from the weight on her chest, spurred by panic when she felt his hardness pressed against her, Joanna managed to free one arm. Striking out blindly, she pummelled Lord Master’s head and bit at the hand covering her mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Despite her efforts, he’d slid his fingers up to her thighs when a shrill female voice cried, ‘Mrs Merrill! What are you doing?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("After a startled instant of immobility, her attacker lurched away from her. Gasping for breath after the removal of his smothering weight, Joanna scrambled to a sitting position on the bed.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Her expression tight and affronted, Lady Masters said, ‘What is the meaning of this outrage?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("‘Now, Lizzie, don’t go off into a pelter,’ Lord Masters said, his tone cajoling. ‘That auburn-haired witch has been throwing herself at me ever since we arrived. There’s only so much temptation a man can withstand.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Lady Master’s look turned contemptuous. ‘In some cases, ’tis very little indeed.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("‘Temptation!’ Joanna croaked furiously, finally able to find her voice. ‘I gave you no encouragement whatsoever! Indeed, I did everything in my power to discourage your unwelcome advances.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("‘Discourage, hah!’ Masters responded. ‘Just look at her, my love. That flaming hair coming loose and her gown awry, cheeks flushed and bosom heaving—why, the hot-blooded wench even bit me!’ He gestured with his bloody hand to his equally bloody lip.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Lady Masters closed her eyes and took a deep, shuddering breath. Now that the danger had passed, Joanna felt a surge of pity for Lady Masters. How awful to be tied for life to a lecher who embarrassed one by trying to debauch one’s governess under one’s very nose! She’d bet her tiny sum of savings this wasn’t the first time, either.")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Opening her eyes a moment later, Lady Masters said quietly, ‘My lord, you will let me handle this, please?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘If you wish, my love.’ Giving a smile to his wife—and throwing Joanna the surly glance of a spoiled child denied the treat he’d been anticipating—Lord Masters ambled out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Lady Masters, I assure you—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Please, Mrs Merrill, do not try to explain. Under these circumstances, I can hardly continue to allow a woman of your…appetites to supervise my children. I must demand that you leave this house at once.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The charge was so unexpected—and so blatantly untrue—that for a moment, Joanna could only stare at her employer in astonishment. Her sympathy for the woman evaporating, she said, ‘But, Lady Masters, surely you can’t blame—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Mrs Merrill, I’ve already said I shall not entertain any excuses. I will be charitable enough to have a groom bring round a gig to convey you to the village in half an hour, but do not test my indulgence by remaining under my roof a minute longer.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Now?’ Joanna asked incredulously. ‘Tis already full dark! And what of my salary for this quarter?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘The lateness of the hour is your own concern. As for your salary—’ Lady Masters looked her up and down ‘—I expect you’ll soon find a way to earn whatever you need.’")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And so, an incoherent blur of time later, her mind still reeling in shock and fury, Joanna found herself deposited at the public house in the village by a surly groom who dropped her without a word, whipped his horse back to a trot and disappeared into the darkness on the long journey back to the manor.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Unwilling to wake the sleeping inhabitants of the inn, unsure yet what story the woman the villagers knew to be governess at the Masters estate could or should tell them about her unexpected appearance, Joanna slipped into the barn. Only ")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("the soft wickers of several equine inhabitants greeted her as she found a thick pile of straw and sank down on to it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Struggling to resist the fear and despair threatening to overcome her, she considered her few possessions—a hurriedly packed bandbox of underthings, shoes and gowns along with the clothes and cloak she wore—and her hoard of coins, which was pitifully small.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Without references or any current prospects of further employment, how would she survive without succumbing to the fate the monstrously unfair Lady Masters had predicted?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("After a moment of blind panic, a reassuring thought calmed her. She’d go to her brother, Greville Anders.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("He’d left the army after Waterloo, she’d learned in the last message she’d had from him, a bitter diatribe against the aristocratic patronage system that had denied him the promotion he felt should have been his after that great battle. Always an indifferent correspondent, he’d sent her nothing since. For all she knew, he might have a wife and a hopeful family at the snug estate he now managed for their more illustrious cousin. He’d not journeyed to London to console her after she had sent word of Thomas’s death and, not wanting at that time to inconvenience him, she’d taken the employment offered by Lady Masters without further thought.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("But, married or single, Greville was the only close family she possessed still in England. Surely he would take her in until she figured out what to do next.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Encouraged by that thought, she settled back into the soft hay with a sigh. Tomorrow she would expend her small savings to purchase coach fare to Blenhem Hill.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("‘So, Ned, what do you think I should do?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("The next afternoon, Sir Edward Austin Greaves raised his gaze from swirling the brandy the sun was illumining to burnished bronze and looked thoughtfully at his friend Nicholas ")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Stanhope, Marquess of Englemere, who sat across from him in Englemere’s library. ‘What is happening at the property now?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("After sipping from his own glass, Nicky shook his head. ‘I can’t be certain, not without inspecting the place personally. Frankly, if it were not for the unrest in the countryside and the general distress occurring even at some of my own holdings, I’d be inclined to think Martin exaggerated. After he retired as my agent, I gave over the management of Blenhem Hill to a distant cousin who approached me about employment after Waterloo. Thought it was the least I could do for one of our brave men, and as he’d served in Wellington’s commissary corps, I assumed he would be capable. Not so, according to Martin, who despite his advanced years still has a sharp mind and a keen eye.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘How bad did Martin say conditions are?’ Ned asked, a ready sympathy rising in him. Except for a few very rich landowners or those with properties as well tended as his, the drop in prices at the end of the war had wreaked havoc with the agrarian economy.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("Nicky grimaced. ‘Wretched enough that Martin urged me to immediately discharge my cousin and his agent, another veteran with whom he’d served. Which I did, leaving me now at a standstill. Blenhem Hill is a damnably long distance from any of my other properties. Though I hate to leave Sarah and our son to make an extended journey, I’d already been intending to visit to view operations at the small stocking mill I had constructed—something Hal recommended.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘A local manufactury that would offer supplementary income for tenant families to offset the drop in crop prices?’ Ned asked. When Nicky nodded, Ned continued, ‘I talked with several estate owners who are doing that. An excellent notion.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘So Hal thought, now that better looms have been designed. You know Hal—’ Nicky grinned as he mentioned their mutual friend Hal Waterman, a big bluff man with a passion for in")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("vestment and a fascination with inventions ‘—always enamoured of the latest gadget. At any rate, I’d planned just a quick stay at Blenhem Hill, but if the distress is as general as Martin reported, I owe it to the tenants to give the place a thorough inspection. And since my expertise is in finance rather than agriculture, I wanted your recommendations on how best to proceed.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Ned was mulling over his answer when a knock sounded at the door, followed by the entry of a graceful, golden-haired lady. Warmth and brightness entered with her, Ned thought, like sun on the fields after a spring rain.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Ned, Nicky, I’m sorry to interrupt, but—’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("His eyes lighting, Nicky jumped up and strode over to kiss his wife’s cheek. ‘Seeing you is always a pleasure, sweeting. Isn’t it, Ned?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Always,’ Ned affirmed, the glow her presence kindled in his own heart tainted by an envy he could not quite subdue. He’d been drawn to Sarah Wellingford the moment they’d met. Had his good friend Nicky not already established a claim on her, he’d have pursued her himself.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Thank you, kind sirs,’ she replied with a twinkle, making them both an exaggerated curtsy. ‘Nicky, Aubrey won’t settle for his nap until you kiss him goodnight. Ned, can you spare him for a few moments?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Of course.’ Turning to Nicky, Ned said, ‘Go see your son. I’ll wait here, making inroads on your brandy and contemplating solutions.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘The demands of fatherhood,’ Nicky said with a sigh Ned didn’t believe for a moment, knowing Nicky adored his little boy as much as he loved his wife. ‘I’ll be back shortly.’ His wife on his arm, Englemere walked out.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Ned watched them leave together, trying to suppress another swell of envy.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Barred from courting the one woman he’d ever cared for, ")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("a countrywoman who might love and esteem a simple gentleman farmer like himself, would Ned ever find another lady Sarah’s equal? Bitterness stirred in his gut. After his recent disillusionment over Amanda, he’d be much less likely to believe it if he ever again encountered one who appeared to be as worthy of his loyalty and affection as his friend’s wife.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Unwillingly his mind caught on the image of the vivacious, charming Amanda. He thought he’d found the lady he’d been seeking when her father, Lord Bronning, a fellow agricultural enthusiast he’d met years ago at the annual meeting at Holkham, had invited him to visit his estate after last autumn’s meeting. Ned had been immediately taken with the bright gold hair, mischievous blue eyes and sparkling wit of Bronning’s country-born, country-bred daughter. Nor had she discouraged him, he recalled, his lip curling.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Oh, no, she’d immediately come forwards to monopolise his attention. Insisting to her papa that she be his guide on walks and drives around her father’s property, she’d impressed him with her knowledge of the estate and entertained him with her needle-sharp commentary.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("His scowl deepened. She’d also fired him to a simmering passion long denied, with the subtle brushes of her fingers against his body, her deliberate, stroking touches to his hands and arms and shoulders, her jutting bosom and moistened lips. Lonely after having lost the company of his two best friends, one happily wed to a girl Ned cherished and the other, Hal Waterman, occupied with his investments in the north, he’d let lust and neediness persuade him what he felt for Amanda was love. And offered for her hand.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Thank a kind Providence he’d first made a formal application to Lord Bronning! To his own chagrin and that gentleman’s embarrassment, her father confessed apologetically that his Amanda, terrible flirt that she was, had vowed to him she would marry none but a wealthy gentleman of high title ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("who, since she’d had enough of rural living, resided for as much of the year as possible in London. Pretty as his little scamp was, Lord Bronning added with fatherly pride, he had no doubt she would accomplish that goal when his sister introduced her in town next Season.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Grateful to at least have been spared the humiliation of having the lady refuse him to his face, Ned had swiftly hied himself home. And vowed in his turn that, being neither as rich as Hal nor as high-born as Nicky, he would be cautious indeed before ever again casting his bruised heart into the matrimonial ring.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Dismissing with irritation that painful episode, he forced his thoughts back to Nicky’s problem. Though Ned wasn’t accounted truly wealthy, his assets tied up as they were in land rather than coin, he did well enough, and managing land was a passion that had never disappointed him. From the first time he’d met like-minded individuals at Coke of Norfolk’s Holkham Hall meeting, he’d devoted all his time and energy to implementing the ideas discussed there and persuading his tenants to adopt the latest and most efficient agricultural techniques.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("But even advanced agricultural practices weren’t always enough to stave off disaster in these hard times, he mused, frowning. The cost of the enclosures essential to modernise agriculture had fallen most heavily on those least able to bear them, the poor farmers who held little beyond their plots of ground in the old commons and wastes. With the drastic fall in the price of wheat and corn, even a well-managed small property could fall into difficulties. The fate of those on a poorly managed one could be grim indeed.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Nicky was right; it was the duty of the local landowner to help his tenants prosper and see that those forced to sell their small plots found employment at a reasonable wage. He was right about the difficulty of the endeavour, too. Rectifying the effects of a long period of mismanagement under current con")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("ditions would pose a difficult challenge even for one of Ned’s experience and expertise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("By heaven, right now he could use a challenge, something to distract him from the lingering bitterness over Amanda and keep the loneliness at bay.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("The idea flashed into mind just as Nicky walked back in.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘You’d had time to mull over the situation,’ Nicky said, pouring himself another fingerful of brandy. ‘What advice do you offer?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Sell Blenhem Hill,’ Ned replied. ‘It’s too far away for you to oversee properly, forcing you to depend on an estate agent of uncertain expertise, and it’s reputed to be in poor condition anyway.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Sell it?’ Nicky echoed. ‘Now? With land and crop prices falling like a duck full of shot, who would be fool enough to purchase a failing agricultural property in the restive Midlands?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Ned smiled. ‘I would.’")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01609908","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fromwaiftogentlemanswife_ch01.vue
// module id = 84
// module chunks = 0